import { useEffect, useState } from "react";
import { FiDownload, FiGrid } from "react-icons/fi";

export function QrPanel({ url }: { url: string }) {
  const [image, setImage] = useState<{ url: string; data: string } | null>(
    null,
  );
  const [error, setError] = useState("");
  useEffect(() => {
    let active = true;
    setImage(null);
    setError("");
    if (url) {
      import("qrcode")
        .then((qr) =>
          qr.toDataURL(url, {
            width: 1024,
            margin: 4,
            errorCorrectionLevel: "M",
            color: { dark: "#17243B", light: "#FFFFFFFF" },
          }),
        )
        .then((data) => {
          if (active) setImage({ url, data });
        })
        .catch(() => {
          if (active)
            setError(
              "QR 코드를 만들지 못했습니다. 주소가 너무 길다면 단축 링크로 다시 시도해주세요.",
            );
        });
    }
    return () => {
      active = false;
    };
  }, [url]);
  const ready = image?.url === url ? image : null;
  return (
    <div className="qr-panel">
      <div className="qr-image">
        {ready ? (
          <img
            src={ready.data}
            width="256"
            height="256"
            alt={`${url}로 이동하는 QR 코드`}
          />
        ) : (
          <div className="qr-placeholder">
            <FiGrid aria-hidden="true" />
            <span>
              {url && !error ? "QR 코드 생성 중…" : "QR 코드 미리보기"}
            </span>
          </div>
        )}
      </div>
      {error ? (
        <p role="alert" className="error-message">
          {error}
        </p>
      ) : null}
      {url ? (
        <p className="qr-url">{url}</p>
      ) : (
        <p className="muted">주소를 입력하면 QR 코드를 만들 수 있어요.</p>
      )}
      {ready ? (
        <a
          className="button primary"
          href={ready.data}
          download={`weplet-qr-${new URL(url).hostname}.png`}
        >
          <FiDownload aria-hidden="true" /> PNG 다운로드
        </a>
      ) : null}
      <p className="small muted">1024 × 1024 px · 배경이 흰색인 PNG</p>
    </div>
  );
}
